<script>
import devData from './dev-data/weekly-order-qty.json'
import api from '@/helpers/api'
import { sumBy, chain } from 'lodash'
import moment from 'moment'
import yearRangeMixin from './year-range.mixin'

export default {
  name: 'total-orders.card',
  mixins: [yearRangeMixin],
  watch: {
    year: 'onRefresh',
    startDate: 'onRefresh',
    endDate: 'onRefresh',
    periodType: 'onRefresh'
  },
  data () {
    return {
      quantity: 0,
      trend: 0,
      series: []
    }
  },
  computed: {
    chartOptions () {
      const color = this.sparklineColor(this.trend)
      return {
        chart: {
          type: 'bar',
          sparkline: {
            enabled: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          colors: [color]
        },
        fill: {
          opacity: 0.85,
          type: 'solid'
        },
        dataLabels: {
          enabled: false
        },
        grid: {
          show: false
        },
        yaxis: {
          min: 0,
          show: false,
          labels: {
            show: false
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        colors: [color]
      }
    }
  },
  mounted () {
    this.onRefresh()
  },
  methods: {
    async onRefresh () {
      let currentRows = []
      let prevRows = []
      let sparkRows = []

      if (process.env.NODE_ENV !== 'production') {
        currentRows = this.filterInRange(
          devData,
          this.rangeStartDate,
          this.rangeEndDate
        )
        prevRows = this.filterInRange(
          devData,
          this.prevRangeStartDate,
          this.prevRangeEndDate
        )
        sparkRows = this.filterInRange(
          devData,
          this.sparklineStartDate,
          this.rangeEndDate
        )
        if (!currentRows.length && !sparkRows.length) {
          currentRows = devData || []
          sparkRows = currentRows
        }
      } else {
        const results = await Promise.all([
          api.stats.weeklyOrderQtyPerCustomer({
            start_date: this.rangeStartFormatted,
            end_date: this.rangeEndFormatted
          }),
          api.stats.weeklyOrderQtyPerCustomer({
            start_date: this.prevRangeStartFormatted,
            end_date: this.prevRangeEndFormatted
          }),
          api.stats.weeklyOrderQtyPerCustomer({
            start_date: this.sparklineStartFormatted,
            end_date: this.rangeEndFormatted
          })
        ])
        currentRows = results[0]
        prevRows = results[1]
        sparkRows = results[2]
      }

      this.quantity = sumBy(currentRows, 'total_orders').toFixed(0)
      const prevQty = sumBy(prevRows, 'total_orders')
      this.trend = this.percentChange(this.quantity, prevQty).toFixed(0)

      const bucket = this.periodType === 'year' ? 'month' : 'isoWeek'
      var grouped = chain(sparkRows)
        .groupBy(x => moment(x.start_date).startOf(bucket))
        .map((data, id) => ({
          start_date: id,
          value: sumBy(data, 'total_orders')
        }))
        .orderBy(x => moment(x.start_date).valueOf(), 'asc')
        .value()

      this.series = [
        {
          name: 'Orders',
          data: grouped.map(x => Number(x.value.toFixed(0)))
        }
      ]
    }
  }
}
</script>
<template>
  <div class="portal-card portal-card--metric">
    <div class="portal-card__metric-top">
      <div>
        <div class="portal-card__eyebrow">{{ $t('Total Orders') }}</div>
        <div class="portal-card__value">{{ quantity }}</div>
      </div>
      <div class="portal-card__sparkline">
        <apexchart
          :key="`ord-${trend}-${periodType}`"
          type="bar"
          height="45"
          width="100%"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
    <div class="portal-card__trend">
      <span
        class="portal-card__trend-value"
        :class="{
          'is-up': trendIsUp(trend),
          'is-down': trendIsDown(trend)
        }"
      >
        <i
          :class="
            trendIsDown(trend)
              ? 'mdi mdi-trending-down'
              : 'mdi mdi-trending-up'
          "
        ></i>
        {{ formatTrendPercent(trend) }}
      </span>
      <span class="portal-card__trend-label">{{ $t(trendLabelKey) }}</span>
    </div>
  </div>
</template>
